import { FlowTypes } from '@adaptis/flow-components';

export interface IPetPaymentProps extends FlowTypes.IFlowControlProps {
  clickNotification: string;
  policyNumberDataField: string;
  firstStep: string;
}

export interface PetPaymentDetails {
  type: String;
  account_name: String;
  bsb: String;
  account_number: String;
  expiry_date: String;
  cvv: String;
}

export interface PaymentParams {
  customerId: String;
  paymentGatewayId: number;
  accountName: String;
  tokenInformation?: String;
  bankCode: String;
  accountNumber: String;
}

export class MESSAGES {
  public static readonly ERROR_REQUIRED = 'Please enter a valid email address.';
  public static readonly ERROR_EMAIL = 'This is a required field.';
  public static readonly ERROR_MINLENGTH = 'Minimum 8 characters required';
  public static readonly ERROR_NUMBER = 'Please enter a valid number.';

  public static readonly ERROR_PAYMENT_TOKEN =
    'Something went wrong. Please try again later.';
  public static readonly ERROR_CREATE_POLICY =
    'The following error occurred while creating your policy: *error*. Please check your credit card details and try again or call us on 1300 952 790.';
  public static readonly ERROR_PAYMENT_FAILED =
    'The payment is failed. Please check again.';
  public static readonly ERROR_PAYMENT_CREDIT_FORM =
    'Please complete all required fields.';
}
